import * as React from "react";

const SvgStillestoppen = React.forwardRef((props, ref) => {
  return (
    <svg
      id="stillestoppen_svg__Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x={0}
      y={0}
      viewBox="0 0 1920 2350"
      xmlSpace="preserve"
      {...props}
			ref={ref}
    >
      <style>{".stillestoppen_svg__st0{fill:#fff}"}</style>
			<g id="spueren">
				<path
					className="stillestoppen_svg__st0"
					d="M1620 109.9l-1.3-.6-98.1 33.6v3.8c24.7 13.3 31.7 25.3 31.7 46.2V327c0 40.5-6.3 50.6-38.6 55.1v5.1H1658v-5c-29.8-3.8-38-15.8-38-53.8V109.9zm112 218.4c0 38-8.2 50-38 53.8v5.1h144.3v-5.1c-31.7-4.4-38.6-14.5-38.6-55.1V191c0-48.7-20.3-81-72.8-81-32.9 0-69.6 22.2-89.2 47.5v1.9c13.3-5.1 29.1-8.9 44.9-8.9 36.7 0 49.4 18.4 49.4 52.5v125.3z"
					id="stillestoppen_svg__spueren-n"
					opacity={0}
				/>
				<g id="stillestoppen_svg__spueren-e" opacity={0}>
					<path
						className="stillestoppen_svg__st0"
						d="M1500.4 207.4c0-49.4-40.5-95.6-103.8-97.5v5.1c27.2 3.2 36.7 40.5 38.6 80.4l-84.8 7.6v4.4h150z"
					/>
					<path
						className="stillestoppen_svg__st0"
						d="M1378.9 111.2c-61.4 7.6-117.7 63.9-117.7 143.7 0 73.4 46.2 137.3 129.1 137.3 73.4 0 110.8-57.6 120.3-87.4l-3.2-2.5c-14.6 20.3-39.9 38.6-84.8 38.6-59.5 0-94.3-49.4-94.3-117.1 0-60.1 19.6-100.7 50.6-107.6v-5z"
					/>
				</g>
				<g id="stillestoppen_svg__spueren-r" opacity={0}>
					<path
						className="stillestoppen_svg__st0"
						d="M1133.4 109.9l-1.3-.6-98.1 33.6v3.8c24 12.7 31.6 25.3 31.6 46.2V327c0 40.5-6.3 50.6-38.6 55.1v5.1h151.3v-5c-29.8-3.2-44.9-13.9-44.9-54.4V109.9zM1216.3 194.8c21.5 0 38.6-15.2 38.6-40.5 0-27.2-15.2-44.3-45.6-44.3-26.6 0-51.9 24.7-60.1 50.6v2.5c10.8-19.6 24.7-25.9 34.2-25.9 1.9 0 4.4.6 5.1 1.3-3.8 3.8-7 13.9-7 23.4 0 19.6 14.5 32.9 34.8 32.9"
					/>
				</g>
				<path
					className="stillestoppen_svg__st0"
					d="M905.8 17.8c-17.8 0-32.2 14.5-32.3 32.2 0 17.7 14.5 32.9 32.3 32.9 18.3 0 32.3-15.2 32.3-32.9.2-17.7-14-32.1-31.7-32.3-.2.1-.4.1-.6.1"
					id="stillestoppen_svg__spueren-dot-right"
					opacity={0}
				/>
				<path
					className="stillestoppen_svg__st0"
					d="M790.6 17.8c-17.8.1-32.2 14.5-32.3 32.3 0 17.7 14.6 33 32.3 33 18.4 0 32.3-15.2 32.3-33 .2-17.7-14-32.1-31.7-32.3h-.6"
					id="stillestoppen_svg__spueren-dot-left"
					opacity={0}
				/>
				<g id="stillestoppen_svg__spueren-u" opacity={0}>
					<path
						className="stillestoppen_svg__st0"
						d="M972.9 113.1l-1.3-.6-108.9 10.8v5.1c36.7 5.1 42.4 15.2 42.4 54.4v207l1.9 1.3 108.2-17.1v-4.4c-38.6-6.3-42.4-14.6-42.4-43.7l.1-212.8zM730.5 308c0 51.9 22.8 82.9 76 82.9 41.1 0 67.7-22.8 83.5-49.4V339c-12.7 7.6-24.7 11.4-43 11.4-37.3 0-48.7-15.8-48.7-59.5V113.1l-1.3-.6-106.4 10.8v5.1c36.7 5.1 39.9 15.2 39.9 54.4V308z"
					/>
				</g>
				<g id="stillestoppen_svg__spueren-p" opacity={0}>
					<path
						className="stillestoppen_svg__st0"
						d="M548.8 389.7v-5.1c-19-1.3-40.5-5.1-54.4-20.2-17.1-17.7-20.2-44.3-20.2-68.4V109.9l-1.3-.6-98.7 33.6v3.8c24 13.3 32.3 24.7 32.3 46.8V472c0 40.5-6.3 50.6-38.6 55.1v4.4h151.3v-4.4c-31.6-4.4-44.9-17.1-44.9-55.7V384c11.4 4.4 33.5 8.2 43.7 8.2 10.2.1 20.6-.8 30.8-2.5"
					/>
					<path
						className="stillestoppen_svg__st0"
						d="M571.6 383.4c76-24 116.5-74.7 116.5-149.4 0-62-26-124.1-111.4-124.1-31.7 0-74.1 20.9-90.5 43v1.3c12-6.3 29.1-9.5 44.3-9.5 58.9 0 86.7 45.6 86.7 111.4 0 53.8-19 105.1-45.6 122.2v5.1z"
					/>
				</g>
				<g id="stillestoppen_svg__spueren-s" opacity={0}>
					<path
						className="stillestoppen_svg__st0"
						d="M249.6 110.6c-47.5 5.7-81 36.7-81 80.4 0 48.1 38 68.4 71.5 86.1 36.1 18.4 67.1 31 67.1 62 0 30.4-19 46.2-43 49.4v3.8c52.5-2.5 97.5-31.6 97.5-89.9 0-41.8-36.7-63.9-77.2-85.4-35.4-17.7-63.3-29.1-63.3-62.7 0-22.1 16.5-37.3 28.5-39.2l-.1-4.5z"
					/>
					<path
						className="stillestoppen_svg__st0"
						d="M295.8 169.9c17.2 0 31.2-14 31.2-31.2s-14-31.2-31.2-31.2-31.2 14-31.2 31.2 14 31.2 31.2 31.2M220.6 399.5c17.2 0 31.2-14 31.2-31.2s-14-31.2-31.2-31.2-31.2 14-31.2 31.2 14 31.2 31.2 31.2"
					/>
				</g>
			</g>
    </svg>
  );
});

export default SvgStillestoppen;

